import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ActionService } from '../../shared/_services/action.service';
import { ActionResponse } from '../../shared/_models/action-response.model';

export interface ReturnType {
  label: string;
  value: string;
}

export interface ReturnTypeLoadParams {
  taxYear: string;
  screenKey: string;
  scenario: string;
  jcdKey: string;
  jcdTaKey: string;
  activityKey: string;
  screenType?: string;
  isLocked?: string;
  issueId?: string;
  issueShortDesc?: string;
  issueIdForTxSave?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReturnTypeProviderService {
  
  private clientKey!: number;
  private baseURL!: string;

  constructor(private actionService: ActionService) {}

  setClientKey(clientKey: number): void {
    this.clientKey = clientKey;
  }

  setBaseURL(baseURL: string): void {
    this.baseURL = baseURL;
  }

  /**
   * Get return types from API
   * Fetches data using ActionService with action_id=33111
   */
  getReturnTypes(params: ReturnTypeLoadParams): Observable<ReturnType[]> {
    // Build HTTP params
    const httpParams = new HttpParams()
      .set('tax_year', params.taxYear)
      .set('screen_key', params.screenKey)
      .set('scenario', params.scenario)
      .set('jcd_key', params.jcdKey)
      .set('jcd_ta_key', params.jcdTaKey)
      .set('activity_key', params.activityKey)
      .set('screen_type', params.screenType || 'grid')
      .set('is_locked', params.isLocked || 'N')
      .set('issue_id', params.issueId || '')
      .set('issue_short_desc', params.issueShortDesc || '')
      .set('issue_id_for_tx_save', params.issueIdForTxSave || '');

    // Make API call using ActionService
    return this.actionService.getActionData(
      this.baseURL,
      33111, // action_id for return types
      this.clientKey,
      httpParams
    ).pipe(
      map((response: ActionResponse) => {
        if (response.callSuccess === '1' && response.jsonObject) {
          // Map { LABEL, VALUE } to ReturnType format
          const returnTypes = response.jsonObject.map((item: any) => ({
            label: item.LABEL,
            value: item.VALUE
          }));
          return returnTypes;
        }
        throw new Error(response.errorMessage || 'Failed to load return types');
      })
    );
  }
}

